import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FileDisplayModeService {
  private fileDisplayMode: string = '';

  setFileDisplayMode(mode: string) {
    this.fileDisplayMode = mode;
  }

  getFileDisplayMode(): string {
    return this.fileDisplayMode;
  }
}
